import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=3383a10d&scoped=true&"
import script from "./ProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./ProfileEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=3383a10d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3383a10d",
  null
  
)

export default component.exports